<section class="py-[74px] min-h-screen bg-[#F5F5F5]">
	<div class="text-center">
		<img class="m-auto mb-24px" src="assets/images/logo-black.svg" alt="logo" />
	</div>
	<form
		[formGroup]="loginForm"
		autocomplete="new-password"
		class="m-auto bg-[#F5F5F5] lg:p-0 p-[24px] rounded-lg max-w-[500px] max-h-[335px]"
	>
		<input autocomplete="false" name="hidden" type="text" class="hidden" />
		<div class="text-center">
			<h1
				class="m-0 text-font-24 text-main-color-black ltr:font-DIN-bold font-bold rtl:font-semibold mb-[6px]"
			>
				{{ 'AUTH.SIGNIN.SIGNIN' | translate }}
			</h1>

			<h3 class="text-font-16 mt-0 text-medium-gray mb-24px leading-6">
				{{ 'AUTH.SIGNIN.TO_BE' | translate }}
			</h3>
		</div>
		<div class="mt-24px">
			<!-- email -->
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
			>
				<mat-label class="text-dark-grey">{{
					'GENERAL_LABELS.EMAIL' | translate
				}}</mat-label>
				<input
					class="text-dark-grey"
					type="text"
					maxlength="150"
					matInput
					placeholder="{{ 'GENERAL_LABELS.EMAIL' | translate }}"
					formControlName="EmailAddress"
					required
				/>
				<img
					(click)="getController('EmailAddress').setValue('')"
					*ngIf="getController('EmailAddress')?.value"
					(click)="getController('name').get('ar')?.reset()"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px]"
					src="./assets/images/close-square.svg"
					alt=""
				/>

				<mat-error>
					<validation-message
						[controller]="getController('EmailAddress')"
						controller_name="GENERAL_LABELS.EMAIL"
						pattern_Message="VALIDATION.EMAIL"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>

			<!-- password -->
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
			>
				<mat-label>{{ 'GENERAL_LABELS.PASSWORD' | translate }}</mat-label>
				<input
					autocomplete="new-password"
					type="password"
					matInput
					placeholder="{{ 'GENERAL_LABELS.PASSWORD' | translate }}"
					formControlName="password"
					[type]="hide ? 'password' : 'text'"
				/>
				<button
					mat-icon-button
					matSuffix
					(click)="hide = !hide"
					[attr.aria-label]="'Hide password'"
					class="text-gray-600 mt-3 custom-btn-icon-style"
					[attr.aria-pressed]="hide"
				>
					<img
						*ngIf="hide"
						src="assets/images/eye.png"
						class="h-[20px]"
						alt="eye-off"
					/>
					<img
						*ngIf="!hide"
						src="assets/images/eye-open.png"
						class="h-[20px]"
						alt="eye-on"
					/>
				</button>
				<mat-error>
					<validation-message
						[controller]="getController('password')"
						controller_name="GENERAL_LABELS.PASSWORD"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>
		<!-- forgot password -->
		<!-- <div class="mb-24px py-[10px] px-12px">
			<p class="text-center text-link mx-3 leading-6 mb-0 sm:text-end">
				<a routerLink="/auth/forget-password">
					{{ 'AUTH.SIGNIN.FORGOT_PASSWORD' | translate }}
				</a>
			</p>
		</div> -->
		<!-- submit -->
		<button
			[disabled]="loginForm.invalid"
			class="bg-gradient text-white w-full p-0"
			mat-button
			(click)="login()"
		>
			{{ 'AUTH.SIGNIN.SIGNIN' | translate }}
		</button>
		<!-- footer -->
		<div class="flex justify-between flex-wrap align-middle py-[10px] mt-24px">
			<div></div>
			<app-language></app-language>
		</div>
	</form>
</section>
